export default class Motive {
    constructor(suspectedReason, suspectedTarget, details, suspects, confirmedReason) {
        this.suspectedReason = suspectedReason;
        this.suspectedTarget = suspectedTarget;
        this.details = details;
        this.suspects = suspects;
        this.confirmedReason = confirmedReason;
    }
}